let abortController = null;
export default {
  state: {
    data: {
      deliveryData: {
        city: null,
      },
      isChangeDisabledElements: true,
      isAvailabilityIn1c: {},
    },
  },
  mutations: {
    'checkout/setData'(store, data) {
      try {
        store.data = {
          ...data,
          deliveryData: {
            ...store.data.deliveryData,
          },
          isAvailabilityIn1c: {
            ...store.data.isAvailabilityIn1c,
          },
        };
      } catch (err) {
        console.error(err);
      }
    },

    'checkout/setChangeDisabledElementsLogic'(store, payload) {
      try {
        store.data.isChangeDisabledElements = payload;
      } catch (err) {
        console.error(err);
      }
    },
    'checkout/setAvailabilityIn1c'(store, payload) {
      try {
        store.data.isAvailabilityIn1c = {
          ...store.data.isAvailabilityIn1c,
          ...payload,
        };
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * Записуем данные в Object для дальнейшей отправки на сервер.
     * @param store
     * @param payload
     */
    'checkout/setRequestData'(store, payload) {
      try {
        const data = JSON.parse(JSON.stringify(store.data));

        const setData = (DataLink, payloadLink) => {
          const { name, value } = payloadLink;

          if (value) {
            DataLink.vue.requestData[name] = value;
          } else {
            delete DataLink.vue.requestData[name];
          }
        };

        switch (App.helpers.getType(payload)) {
          case 'object':
            setData(data, payload);
            break;
          case 'array':
            payload.forEach((el) => setData(data, el));
            break;
        }

        store.data = data;
      } catch (err) {
        console.error(err);
      }
    },
    'checkout/setCityData'(store, data) {
      try {
        store.data = {
          ...store.data,
          deliveryData: {
            ...store.data.deliveryData,
            city: data,
          },
        };
      } catch (err) {
        console.error(err);
      }
    },
  },
  actions: {
    /**
     * Собираем данные и делаем запрос на сервер при изменении данных
     *
     * @param getters
     * @param commit
     * @param data
     * @param payload
     * @return {Q.Promise<void>}
     */
    async 'checkout/setAjax'({ getters, commit, dispatch, state: { data } }, payload) {
      try {
        commit('global/loaderStart');
        if (abortController) {
          abortController.abort();
          abortController = null;
        }
        abortController = new AbortController();

        const { requestData, settings } = data?.vue;
        const { requestFields } = data.vue.settings;

        // формируем данные для multidimensional array

        const formData = {
          order: {
            ...requestData,
            [settings.actionKey]: settings.actionSave,
          },
          [settings.actionKey]: settings.actionRefresh,
        };

        if (payload) {
          formData.order[payload.name] = payload.value;
        }

        for (const key in requestFields) {
          if (key === 'double') {
            requestFields[key].forEach((el) => (formData[el] = formData.order[el]));
          } else if (key === 'main') {
            requestFields[key].forEach((el) => {
              formData[el] = formData.order[el];
              delete formData.order[el];
            });
          }
        }

        // отправляем данные на сервер

        const response = await axios.post(settings.ajaxUrl, formData, {
          signal: abortController.signal,
        });

        if (!response.data.error) {
          commit('checkout/setData', response.data.order);
        } else {
          throw `request error status ${response.status}`;
        }
      } catch (err) {
        if (err.message === 'canceled' && process.env.NODE_ENV === 'production') return;
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    /**
     * Собираем данные и сохраняем заказ после ответа делаем редирект
     *
     * @param getters
     * @param commit
     * @param data
     * @param payload
     * @return {Q.Promise<void>}
     */
    async 'checkout/saveOrder'({ state: { data }, dispatch, commit }) {
      try {
        commit('global/loaderStart');
        const { requestData, settings } = data?.vue;

        const formData = {
          ...requestData,
          [settings.actionKey]: settings.actionSave,
        };

        /**
         * @see https://sova-jewels.atlassian.net/wiki/spaces/SOVA/pages/328695811/US+22.12+-+IPOST
         * before making order delivery could be deactivated
         * */
        if (requestData?.DELIVERY_ID == 8) {
          await dispatch('checkout/setAjax');
        }

        const response = await axios.post(settings.ajaxUrl, formData);

        if (response?.data?.order?.REDIRECT_URL) {
          location.href = response.data.order.REDIRECT_URL;
        } else {
          const errorTypes = response?.data?.order?.ERROR;
          console.log(errorTypes);
        }
        commit('global/loaderStop');
      } catch (err) {
        console.error(err);
      }
    },
    /** delivery * */
    async 'checkout/initIPostDelivery'({ state: { data }, getters, commit, dispatch }) {
      try {
        const getIPostDelivery = getters['checkout/getIPostDelivery'];
        const IPostFieldsString = window.sessionStorage.getItem('IPostFields');
        // if transition from IPost
        if (IPostFieldsString) {
          const id = getIPostDelivery?.ID;
          if (IPostFieldsString && id) {
            commit('checkout/setRequestData', { name: data?.vue?.delivery?.inputName, value: id });
            commit('checkout/setChangeDisabledElementsLogic', false);
            await dispatch('checkout/setAjax');
            commit('checkout/setChangeDisabledElementsLogic', true);
            dispatch('checkout/fillIPostFields');
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    'checkout/fillIPostFields'({ state: { data }, commit, dispatch }) {
      try {
        const IPostFieldsString = window.sessionStorage.getItem('IPostFields');
        if (IPostFieldsString) {
          const IPostFields = JSON.parse(IPostFieldsString);
          Object.values(data.vue.delivery.props)?.forEach((el) => {
            if (el.CODE in IPostFields) {
              if (el.CODE === 'CITY') {
                commit('checkout/setCityData', IPostFields[el.CODE]);
                commit('checkout/setRequestData', {
                  name: el.inputName,
                  value: IPostFields[el.CODE]?.UF_NAME,
                });
              } else {
                commit('checkout/setRequestData', {
                  name: el.inputName,
                  value: IPostFields[el.CODE],
                });
              }
            }
          });
          dispatch('checkout/setAjax');
        }
      } catch (err) {
        console.error(err);
      }
    },
    async 'checkout/changeCity'({ state: { data }, commit, dispatch, getters }, payload) {
      try {
        const props = Object.values(data.vue.delivery.props);
        const getActiveDelivery = getters['checkout/getActiveDelivery'];
        const getWarehousesInputName = props?.find((el) => el.CODE === 'NP_DEPARTMENT')?.inputName;
        const getParcelInputName = props?.find((el) => el.CODE === 'NP_PARCEL')?.inputName;
        const getCityKey = props?.find((el) => el.CODE === 'CITY')?.inputName ?? 'ORDER_PROP_5';
        /** clean active shop * */
        if (getActiveDelivery?.storeInputName) {
          const inputStoreID = data?.vue?.delivery?.inputStoreID;
          commit('checkout/setRequestData', [
            { name: getActiveDelivery.storeInputName },
            { name: inputStoreID },
          ]);
        }
        /** clean active warehouse * */
        if (getWarehousesInputName) {
          commit('checkout/setRequestData', [{ name: getWarehousesInputName }]);
        }
        /** clean active parcel * */
        if (getParcelInputName) {
          commit('checkout/setRequestData', [{ name: getParcelInputName }]);
        }

        commit('checkout/setCityData', payload);
        commit('checkout/setRequestData', { name: getCityKey, value: payload.UF_NAME });
        dispatch('checkout/setAjax');
      } catch (err) {
        console.error(err);
      }
    },
    async 'checkout/initCity'({
      state: { data },
      rootState: {
        cities: {
          data: { userCity },
        },
      },
      commit,
      dispatch,
    }) {
      const IPostFieldsString = window.sessionStorage.getItem('IPostFields');

      if (IPostFieldsString) return;

      // is userDeliveryAddresses present don't init city
      if (0 && data.vue?.userDeliveryAddresses?.items?.length) return;

      // if (data.vue?.userDeliveryAddresses?.items?.filter((el) => !el.DISABLED).length) return;

      if (userCity?.UF_NAME) {
        const props = Object.values(data.vue.delivery.props);
        const getCityKey = props?.find((el) => el.CODE === 'CITY')?.inputName ?? 'ORDER_PROP_5';

        commit('checkout/setCityData', userCity);
        commit('checkout/setRequestData', { name: getCityKey, value: userCity?.UF_NAME });
        dispatch('checkout/setAjax');
      }
    },
    /** Mechanic of auto receiving/generating the SOVA Club Card for non authorized users */
    async 'checkout/getCreateClubCardForGuests'({ state: { data }, commit }, payload) {
      try {
        commit('global/loaderStart');
        const { requestData, userFields } = data?.vue;
        const requestParams = { ...requestData };

        // /**
        //  * Fields, that take part only in Sova Club mechanic (name, surname, phone). In order to don't make unnecessary requires on server
        //  * @type {string[]}
        //  */
        // const codes = ['USER_LAST_NAME', 'USER_NAME', 'PHONE'];
        // const fields = userFields.props.filter(el => codes.includes(el.CODE));
        // const propCodes = fields.map(el => el.inputName);

        if (payload) {
          requestParams[payload.name] = payload.value;
        }
        const { path, action } = data.vue.routes.getCreateClubCardForGuests;

        const response = await axios.post(path, { action, ...requestParams });

        if (response.data.basket) commit('basket/setState', response.data.basket);

        if (response.status !== 200) throw `bad request response status: ${response.status}`;
      } catch (err) {
        console.error(err);
      } finally {
        commit('global/loaderStop');
      }
    },
    async 'checkout/isProductAvailableIn1C'({ state: { data }, commit }, payload) {
      try {
        if (payload?.useLoader) {
          commit('global/loaderStart');
        }
        const { article, skuMatrix } = payload;
        let requestData = { article };
        const size = skuMatrix?.SIZES?.items?.find((el) => el.active);
        if (size) {
          requestData = { ...requestData, size: size.displayValue };
        }
        const { path, action } = data.vue.routes.checkProductAvailabilityIn1C;
        const response = await axios.post(path, { action, ...requestData });
        const { isAvailableIn1C } = response?.data;

        commit('checkout/setAvailabilityIn1c', {
          [payload.id]: isAvailableIn1C,
        });

        return isAvailableIn1C;

        if (response.status !== 200) throw `bad request response status: ${response.status}`;
      } catch (err) {
        console.error(err);
      } finally {
        if (payload?.useLoader) {
          commit('global/loaderStop');
        }
      }
    },
  },
  getters: {
    'checkout/getNotAvailableProductsIn1C': ({ data }) => {
      try {
        const products = data?.vue?.products;
        return products?.filter((el) => !data.isAvailabilityIn1c[el.id]);
      } catch (err) {
        console.error(err);
      }
    },
    'checkout/checkIfProductIsNotAvailable1C':
      ({ data }) =>
      (id) => {
        try {
          const products = data?.vue?.products;

          return !!products?.find((el) => {
            // const productId = el?.offer?.id || el?.id;
            if (el?.id == id && !data.isAvailabilityIn1c[id]) {
              return true;
            }
            return false;
          });
          // return !data?.isAvailabilityIn1c[id];
        } catch (err) {
          console.error(err);
        }
      },
    /** delivery * */
    'checkout/getIPostDelivery': ({ data }) => {
      try {
        if (data?.vue)
          return Object.values(data?.vue?.delivery?.items).find((el) => el.NAME.includes('IPOST'));
      } catch (err) {
        console.error(err);
      }
    },
    'checkout/getActiveDelivery': ({ data }) => {
      const items = data.vue?.delivery?.items;
      if (items) {
        return Object.values(items).find((el) => el.CHECKED === 'Y');
      }
    },
    /** pay system * */
    'checkout/getPaySystems': ({ data }) =>
      data.vue?.paySystem?.items?.filter((el) => !el?.DISABLED),
    /** pay system * */
    'checkout/getUserFields': ({ data }) =>
      data.vue?.userFields?.props?.filter(
        (el) =>
          el.CODE !== 'CERTIFICATE' &&
          el.CODE !== 'I_HAVE_NO_UKR_PHONE' &&
          el.CODE !== 'PHONE_UKRAINE'
      ),
  },
};
